import { render, staticRenderFns } from "./MoreGeGu.vue?vue&type=template&id=214862de"
import script from "./MoreGeGu.vue?vue&type=script&lang=js"
export * from "./MoreGeGu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports